import { COUNTRY_LABELS } from '~/utils'

export default defineNuxtPlugin(() => {
  if (import.meta.server) {
    return
  }
  const { $getLocale, $switchLocale } = useI18n()
  const { features } = storeToRefs(useFeatureStore())

  const userLocale = useCookie<string>('user-locale', {
    path: '/'
  })

  const supportedLanguages = features.value?.languages_parsed
  if (!supportedLanguages?.length) return

  const configuredLanguages = new Set(Object.keys(COUNTRY_LABELS))
  const availableLanguages = new Set(
    supportedLanguages.filter((language) => configuredLanguages.has(language))
  )

  const requestedLocale = userLocale.value || $getLocale()
  const locale = availableLanguages.has(requestedLocale)
    ? requestedLocale
    : availableLanguages.has('en')
      ? 'en'
      : [...availableLanguages][0] || 'en'

  if ($getLocale() !== locale) {
    $switchLocale(locale)
  }
})
